import { useQuery } from 'react-query';
import apiEndPoints from 'services/apiEndPoints';
import makeApiRequest from 'services/makeApiRequest';

import createQueryParamsForGetReq from 'helper/createQueryParamsForGetReq';

export default function useGetAllTaskboardMembers(id) {
  return useQuery(['get-all-taskboard_members', id], async () => {
    const res = await makeApiRequest.get(
      createQueryParamsForGetReq(apiEndPoints.TASKBOARD_MEMBERS, {
        task_board_id: id,
      })
    );
    return res.data;
  });
}
